import React, { CSSProperties, FC } from 'react';
import { useFetchStreetSuggestions } from '../../hooks/useFetchStreetSuggestions';
import DebouncedAutoComplete from './DebouncedAutoComplete';

export type StreetInputProps = {
  label: string;
  postalCode?: string;
  value: string;
  countryISO?: string;
  onBlur?: () => void;
  onChange: (street: string) => void;
  validationMessage?: string;
  style?: CSSProperties;
};

const StreetInput: FC<StreetInputProps> = ({
  label,
  value,
  postalCode,
  countryISO,
  onBlur,
  onChange,
  validationMessage,
  style,
}) => {
  const fetchStreetSuggestions = useFetchStreetSuggestions({ countryISO, postalCode, limit: 10 });

  return (
    <DebouncedAutoComplete
      label={label}
      value={value}
      dataCy="addressStreet"
      onBlur={onBlur}
      onChange={onChange}
      fetchSuggestions={fetchStreetSuggestions}
      style={style}
      validationMessage={validationMessage}
    />
  );
};

export default StreetInput;
